import XLSX from 'xlsx-js-style';
import { GetColab } from '../../modules/Colab/types';
import { formatDateTimeCompact } from '../shared/utils';

type ColumnSpacing = {
  [index: string]: number;
};

function convertToExcel(data: GetColab[]) {
  const excelData = data.map(
    ({
      created,
      transcribed,
      translated,
      systemLanguage,
      vehicleModel,
      vehicleModelYear,
      vehicleMarket,
      age,
      fromAppName,
      category,
      fromAppVersion,
      dhuVersion,
      ihuSoftwareVersion,
      reference,
      vin,
      VIN,
    }) => ({
      'Submission Date': created ? formatDateTimeCompact(created) : '',
      'Transcribe Feedback': transcribed ? transcribed : '',
      'Translated Text': translated ? translated : '',
      'System Language': systemLanguage ? systemLanguage : '',
      'Car Model': vehicleModel ? vehicleModel : '',
      'Car Model Year': vehicleModelYear ? vehicleModelYear : '',
      Market: vehicleMarket ? vehicleMarket : '',
      VIN: vin || VIN || '',
      Age: age ? age : '',
      'Coming From App': fromAppName ? fromAppName : '',
      Category: category ? category : '',
      'App Version': fromAppVersion ? fromAppVersion : '',
      'HU SW Version': dhuVersion || ihuSoftwareVersion || '',
      Comment: reference ? reference : '',
    }),
  );

  const headerWidths: ColumnSpacing = {
    'Submission Date': 220,
    'Transcribe Feedback': 450,
    'Translated Text': 450,
    'System Language': 245,
    'Car Model': 160,
    'Car Model Year': 230,
    Market: 165,
    VIN: 220,
    Age: 85,
    'Coming From App': 260,
    Category: 160,
    'App Version': 425,
    'HU SW Version': 295,
    Comment: 430,
  };

  excelData.map(item => {
    item['Car Model'] === 'CX11' ? (item['Car Model'] = 'CX11 A1') : item['Car Model'];
  });

  const headers = Object.keys(excelData[0]);

  const ws = XLSX.utils.json_to_sheet(excelData, { header: headers });

  headers.forEach((header, index) => {
    const cell = ws[XLSX.utils.encode_cell({ r: 0, c: index })];
    if (cell) {
      cell.s = {
        font: {
          color: { rgb: 'FFFFFF' },
          sz: 14,
          bold: true,
        },
        fill: {
          fgColor: { rgb: '242424' },
        },
      };
    }
  });

  for (let i = 1; i <= excelData.length; i++) {
    const rowColor = i % 2 === 0 ? 'f0fdfa' : 'ffffff';
    for (let j = 0; j < headers.length; j++) {
      const cell = ws[XLSX.utils.encode_cell({ r: i, c: j })];

      cell.s = {
        fill: {
          fgColor: { rgb: rowColor },
        },
        border: {
          top: { style: 'thin', color: { rgb: '000000' } },
          left: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } },
        },
      };
    }
  }

  const pixelFormat = 0.5454;
  const columnWidths = headers.map(header => ({
    wpx: headerWidths[header] ? headerWidths[header] * pixelFormat : 150,
  }));
  ws['!cols'] = columnWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');

  XLSX.writeFile(wb, 'Colab.xlsx');
}

export { convertToExcel };
